import { axiosB2 } from './axiosB2';
import { getB2Payload, parseB2Envelope } from './b2Envelope';

/**
 * Set marketing consent for one account (company). B2: SetMarketingConsentAccount
 * @param {{ id: number, marketingStatusId: number }} params
 */
export function setMarketingConsentAccount({ id, marketingStatusId }) {
    return axiosB2
        .post('SetMarketingConsentAccount', {
            id: Number(id),
            marketingStatusId: Number(marketingStatusId),
        })
        .then(({ data }) => getB2Payload(parseB2Envelope(data)));
}

/**
 * Set marketing consent for one contact. B2: SetMarketingConsentContact
 * @param {{ id: number, marketingStatusId: number }} params
 */
export function setMarketingConsentContact({ id, marketingStatusId }) {
    return axiosB2
        .post('SetMarketingConsentContact', {
            id: Number(id),
            marketingStatusId: Number(marketingStatusId),
        })
        .then(({ data }) => getB2Payload(parseB2Envelope(data)));
}
